import { render, staticRenderFns } from "./VueIconBase.vue?vue&type=template&id=9e1e2bf6&scoped=true&"
import script from "./VueIconBase.vue?vue&type=script&lang=js&"
export * from "./VueIconBase.vue?vue&type=script&lang=js&"
import style0 from "./VueIconBase.vue?vue&type=style&index=0&id=9e1e2bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1e2bf6",
  null
  
)

export default component.exports